import campaignApi from 'api/campaignApi'
import {
  AppCampaignListRequest,
  AppCampaignListResponse,
  AppCampaignSaveRequest,
  CampaignListRequest,
  CampaignListResponse,
  CampaignSaveRequest
} from './types'
import { AudienceListResponse } from '../audience/types'

const CampaignApiSlice = campaignApi.injectEndpoints({
  endpoints: (build) => ({
    createCampaign: build.mutation<CampaignListResponse, CampaignSaveRequest>({
      query: (campaignData) => ({
        url: `/whatsapp/campaign`,
        method: 'POST',
        data: campaignData
      }),
      invalidatesTags: ['campaign']
    }),

    getAllCampaigns: build.query<CampaignListResponse, CampaignListRequest>({
      query: ({ filters, page }) => {
        const params: { [key: string]: any } = {
          size: page?.size,
          page: page?.number ? page.number - 1 : 0
        }

        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: `/getAllCampaigns`,
          method: 'GET',
          params
        }
      },
      providesTags: ['campaign']
    }),
    getAppCampaigns: build.query<
      AppCampaignListResponse,
      AppCampaignListRequest
    >({
      query: ({ filters, page }) => {
        const params: { [key: string]: any } = {
          size: page?.size,
          page: page?.number ? page.number - 1 : 0
        }

        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: `/getAllCampaigns`,
          method: 'GET',
          params
        }
      },
      providesTags: ['campaign']
    }),
    fetchAudienceList: build.query<AudienceListResponse, void>({
      query: () => ({
        url: '/audiences/extended',
        method: 'GET'
      }),
      providesTags: ['audience']
    }),

    fetchAudienceCount: build.query<number, { audienceId: number | null }>({
      query: ({ audienceId }) => ({
        url: `/client-count/${audienceId}`,
        method: 'GET'
      }),
      providesTags: ['audience']
    }),

    updateCampaign: build.mutation<CampaignListResponse, { payload: any }>({
      query: ({ payload }) => ({
        url: `/campaigns/${payload.id}`,
        method: 'PATCH',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['campaign']
    }),
    updateWhatsappCampaign: build.mutation<
      CampaignListResponse,
      { payload: any }
    >({
      query: ({ payload }) => ({
        url: `/whatsapp/campaign/${payload.id}`,
        method: 'PUT',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['campaign']
    }),

    deleteCampaign: build.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `/campaigns/${id}`,
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${process.env.AUTH_TOKEN}`
        }
      }),
      invalidatesTags: ['campaign']
    }),
    createAppCampaign: build.mutation<
      AppCampaignListResponse,
      AppCampaignSaveRequest
    >({
      query: (campaignData) => ({
        url: `/campaigns/extended`,
        method: 'POST',
        data: campaignData
      }),
      invalidatesTags: ['campaign']
    })
  })
})

export const {
  useGetAllCampaignsQuery,
  useFetchAudienceListQuery,
  useFetchAudienceCountQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
  useCreateAppCampaignMutation,
  useGetAppCampaignsQuery,
  useUpdateWhatsappCampaignMutation
} = CampaignApiSlice
